import Cookies from 'js-cookie';
import { ACCESS_TOKEN_COOKIE_NAME } from '../constants';
/**
 * A hook to get the access token for the current user.
 */

var useAccessToken = function useAccessToken() {
  return Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
};

export default useAccessToken;